import ButtonStratto from "./ButtonStratto";

export default ButtonStratto;
